import { initExperiment } from "utils/experiment-enrolment"
import "./index.scss"

export default function bannerPositionExperiment() {
  const element = document.querySelector<HTMLElement>(
    '[data-experiment-id="202609_banner_position_v1"]',
  )
  if (!element) return

  const viewport = window.matchMedia("(min-width: 758px)")
  const start = () => {
    if (!viewport.matches) return

    try {
      initExperiment(element)
    } catch {
      // Analytics failures must not prevent the forecast page from initializing.
    }
    viewport.removeListener(start)
  }
  viewport.addListener(start)
  start()
}
